import ServerError from '@/common/utils/errors/ServerError';

export default class NotFoundError extends ServerError {
  constructor(response: Response, body: ErrorBody) {
    super(response, body, undefined, 'Not found');

    this.message = ((this.body as ErrorBody)?.error?.error?.message)
      || ((this.body as ErrorBody)?.message)
      || 'Object you are referring to is not found';
  }
}
